import { DynamicTab } from "../../../components/Page";
import IexDaily from "./IexDaily";
import PriceForcastingIEXDAM from "./PriceForcastingIEXDAM";
import PriceForcastingRTM from "./PriceForcastingRTM";
import PriceForecastIEXWrapper from "./PriceForecastIEXWrapper";

const PriceForecastWrapper = () => {
  return (
    <DynamicTab
      header="Price Forecast"
      tabs={{
        // DAM: <PriceForcastingIEXDAM />,
        DAM: <PriceForecastIEXWrapper />,
        RTM: <PriceForcastingRTM />,
        // "DAM (Daily)": <IexDaily />,
      }}
      disabledTabs={["DAM (Daily)", "RTM"]}
    />
  );
};

export default PriceForecastWrapper;
